import BaseHttp from 'src/commons/store/BaseHttp'
import {
  API_URL,
  HttpSuccessType1,
  HttpSuccessType2,
  ResultPagination,
  HttpSuccessType4,
} from 'src/commons/utils/Commons'
import DealWithHttp from 'src/commons/store/DealWithHttp'
import MobXHttp from 'src/commons/store/MobXHttp'
/* 消息统计接口  */
const getMessageStatistics = BaseHttp<null, ApiResult3<{ iterationNoticeNum: number; sysNoticeNum: number }>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/anon/information/statisticsPlatform`,
})
export const DWgetMessageStatistics = DealWithHttp(getMessageStatistics, HttpSuccessType2)

/* 活动页启动游戏 */
const activityStartGpGame = BaseHttp<TactivityStartGame, ApiResult<TStartGameHttp>>({
  Type: 'Post',
  Url: `${API_URL.BOX_WEB}/api/activity/startGpGame`,
})

const DWactivityStartGpGame = DealWithHttp(activityStartGpGame, HttpSuccessType1)

export const activityStartGpGameHS = MobXHttp(DWactivityStartGpGame)

/*#region 消息详情 */
const getMessageDetail = BaseHttp<
  { product: 'sys_notice' | 'iteration_notice'; id: number },
  ApiResult3<MessageDetail>
>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/anon/information/platformDetail`,
})
export const DWgetMessageDetail = DealWithHttp(getMessageDetail, HttpSuccessType2)

/*#region 获取最新发布的消息数量 */
const getMessageNum = BaseHttp<{ days: number }, ApiResult3<number>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/anon/information/countLatestPlatform`,
})
export const DWgetMessageNum = DealWithHttp(getMessageNum, HttpSuccessType2)

/*#region 获取消息列表 */
const getPlatformMessageList = BaseHttp<
  { product: 'sys_notice' | 'iteration_notice' | 'launch_page_notice'; pageNo: number; pageSize?: number },
  ApiResult3<WithPages<MessageList>>
>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/anon/information/platformList`,
})
export const DWgetPlatformMessageList = DealWithHttp(getPlatformMessageList, HttpSuccessType2)
export const DWgetPlatformMessageListHS = MobXHttp(DWgetPlatformMessageList)

/*#region 发帖板块列表 */
const getPushPostsPlateList = BaseHttp<
  null,
  ApiResult3<
    Array<{
      gameId: number
      gameName: string
      openTopic: number
    }>
  >
>({
  Type: 'Get',
  Url: `${API_URL.BBS_WEB}/api/box/inner/user/inventedGame`,
})
const DWgetPushPostsPlateList = DealWithHttp(getPushPostsPlateList, HttpSuccessType2)
export const getPushPostsPlateListHS = MobXHttp(DWgetPushPostsPlateList)

/*#region 个人用户信息统计 */
const getUserInfoPostsStatistics = BaseHttp<{ userId: number }, ApiResult3<PostsUserInfo>>({
  Type: 'Get',
  Url: `${API_URL.BBS_WEB}/api/box/inner/user/activeStatistics`,
})
const DWgetUserInfoPostsStatistics = DealWithHttp(getUserInfoPostsStatistics, HttpSuccessType2)
export const getUserInfoPostsStatisticsHS = MobXHttp(DWgetUserInfoPostsStatistics)

/*#region 发帖 获取所有游戏 */
const getBoxUserInfoPosts = BaseHttp<{ userId: number }, ApiResult3<PostsUserInfo>>({
  Type: 'Get',
  Url: `${API_URL.BBS_WEB}/api/box/anon/user/activeStatistics`,
})
const DWgetBoxUserInfoPosts = DealWithHttp(getBoxUserInfoPosts, HttpSuccessType2)
export const getBoxUserInfoPostsHS = MobXHttp(DWgetBoxUserInfoPosts)

/*#region 发帖 获取所有游戏 */
const getAllGames = BaseHttp<
  null,
  ApiResult3<Array<{ id: number; gameId: number; gameName: string; openTopic: number }>>
>({
  Type: 'Get',
  Url: `${API_URL.BBS_WEB}/api/box/inner/topic/game`,
})
const DWgetAllGames = DealWithHttp(getAllGames, HttpSuccessType2)
export const getAllGamesHS = MobXHttp(DWgetAllGames)

/*#region 热游专区统计列表 */
const getFeedbackSpecPosts = BaseHttp<{ pageNo?: number; pageSize?: number }, ApiResult3<SpecPosts>>({
  Type: 'Get',
  Url: `${API_URL.BBS_WEB}/api/box/anon/feedback/list`,
})
const DWgetFeedbackSpecPosts = DealWithHttp(getFeedbackSpecPosts, HttpSuccessType2)
export const getFeedbackSpecPostsHS = MobXHttp(DWgetFeedbackSpecPosts)

/*#region 热游专区统计列表 */
const getHotsSpecPosts = BaseHttp<{ pageNo?: number; pageSize?: number }, ApiResult3<SpecPosts>>({
  Type: 'Get',
  Url: `${API_URL.BBS_WEB}/api/box/anon/hot/list`,
})
const DWgetHotsSpecPosts = DealWithHttp(getHotsSpecPosts, HttpSuccessType2)
export const getHotsSpecPostsHS = MobXHttp(DWgetHotsSpecPosts)

/*#region 帖子首页统计 */
const getPostsStatistics = BaseHttp<null, ApiResult3<PostsStatistics>>({
  Type: 'Get',
  Url: `${API_URL.BBS_WEB}/api/box/anon/index/statistics`,
})

const DWgetPostsStatistics = DealWithHttp(getPostsStatistics, HttpSuccessType2)

export const getPostsStatisticsHS = MobXHttp(DWgetPostsStatistics)

/** 重新发布帖子 */
const againPushPosts = BaseHttp<{ id: number }, ApiResult3<0 | 1>>({
  Type: 'Get',
  Url: `${API_URL.BBS_WEB}/api/box/inner/topic/republish`,
})
export const DWagainPushPosts = DealWithHttp(againPushPosts, HttpSuccessType2)
/*#region 举报帖子和评论 */
const reportMessage = BaseHttp<
  { refId: number; reportType: 0 | 1; reason: number; added: string; beenReportUserId: number },
  ApiResult3<any>
>({
  Type: 'Post',
  Url: `${API_URL.BBS_WEB}/api/box/inner/report`,
})
export const DWreportMessage = DealWithHttp(reportMessage, HttpSuccessType2)

/*#region 获取置顶的帖子 */
const getTopAllPosts = BaseHttp<
  {
    pageNo: number
    pageSize: number
    sort?: number | null
    title?: string
    categoryId?: string | number
  } & GameLibraryId,
  ApiResult3<PageBBSResult<TBBSListItem>>
>({
  Type: 'Get',
  Url: `${API_URL.BBS_WEB}/api/box/anon/topic/pageTop`,
})

const DWgetTopAllPosts = DealWithHttp(getTopAllPosts, HttpSuccessType2)

export const getTopAllPostsHS = MobXHttp(DWgetTopAllPosts)
/*#endregion*/

/*#region 获取置顶的帖子 */
const getTopPosts = BaseHttp<GameLibraryId, ApiResult3<TBBSListItem[]>>({
  Type: 'Get',
  Url: `${API_URL.BBS_WEB}/api/box/anon/topic/top`,
})

const DWgetTopPosts = DealWithHttp(getTopPosts, HttpSuccessType2)

export const getTopPostsHS = MobXHttp(DWgetTopPosts)
/*#endregion*/

const handleCommentLike = BaseHttp<{ id: number }, ApiResult2<number>>({
  Type: 'Get',
  Url: `${API_URL.BBS_WEB}/api/box/inner/comment/up`,
})
export const DWHandleCommentLike = DealWithHttp(handleCommentLike, HttpSuccessType2)

/** 话题点赞 */
const handleLikeTopics = BaseHttp<{ id: number }, ApiResult2<number>>({
  Type: 'Get',
  Url: `${API_URL.BBS_WEB}/api/box/inner/topic/up`,
})
export const DWHandleLikeTopics = DealWithHttp(handleLikeTopics, HttpSuccessType2)

/** 获取该游戏是否开启论坛功能 */
const getGamesIsOpenTopics = BaseHttp<GameLibraryId, ApiResult2<boolean>>({
  Type: 'Get',
  Url: `${API_URL.BBS_WEB}/api/box/topic/isOpen`,
})
const DWGetGamesIsOpenTopics = DealWithHttp(getGamesIsOpenTopics, HttpSuccessType2)
export const GetGamesIsOpenTopicsHS = MobXHttp(DWGetGamesIsOpenTopics)
/** 获取用户可以发帖的分类 */
const getUserTopicsCategory = BaseHttp<GameLibraryId, ApiResult2<Array<TopicsCategory>>>({
  Type: 'Get',
  Url: `${API_URL.BBS_WEB}/api/box/inner/topic/category/user`,
})

export const DWGetUserTopicsCategory = DealWithHttp(getUserTopicsCategory, HttpSuccessType2)
export const GetUserTopicsCategoryHS = MobXHttp(DWGetUserTopicsCategory)

/** 获取论坛话题分类 */
const getTopicsCategory = BaseHttp<GameLibraryId, ApiResult2<Array<TopicsCategory>>>({
  Type: 'Get',
  Url: `${API_URL.BBS_WEB}/api/box/topic/category`,
})
const DWGetTopicsCategory = DealWithHttp(getTopicsCategory, HttpSuccessType2)
export const GetTopicsCategoryHS = MobXHttp(DWGetTopicsCategory)

/** 获取邀请人手机号 */
const getVipInvitedUserPhone = BaseHttp<undefined, ApiResult3<any>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/vip/invited/user/phone`,
})
export const DWGetVipInvitedUserPhone = DealWithHttp(getVipInvitedUserPhone, HttpSuccessType2)
export const GetVipInvitedUserPhoneHS = MobXHttp(DWGetVipInvitedUserPhone)
/** 绑定邀请码 */
const bindInviter = BaseHttp<{ inviterCode: string }, ApiResult3<any>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/vip/pre/bind/inviter`,
})
export const DWbindInviter = DealWithHttp(bindInviter, HttpSuccessType2)
/** 绑定邀请人 */
const vipBindInviter = BaseHttp<{ mobile: string; isNew?: number }, ApiResult3<any>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/user/bind/inviter`,
})
export const DWVipBindInviter = DealWithHttp(vipBindInviter, HttpSuccessType2)

/*#region 人工实名认证*/
const SaveAuthInfo = BaseHttp<
  {
    name: string
    idCardNo: string
    certificatesType: 'idcard' | 'passport' | 'exitentry_permit' | 'mainland_permit'
    certificatesImage: string
  },
  ApiResult3<null>
>({
  Type: 'Post',
  Url: `${API_URL.BOX_WEB}/bind/realNameAuthExamine`,
})
export const DWSaveAuthInfo = DealWithHttp(SaveAuthInfo, HttpSuccessType2)

/*#region 查询用户是否引导过某板块 */
const getIsOpenGuide = BaseHttp<{ plate: string; token?: string }, ApiResult3<boolean>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/user/guide/check`,
})

export const DWGetIsOpenGuide = DealWithHttp(getIsOpenGuide, HttpSuccessType2)
// export const GetIsOpenGuideHS = MobXHttp(DWGetIsOpenGuide)

/*#region 保存C5跳转地址*/
const SaveUrlHttp = BaseHttp<{ op: string; subjectId: string; mss: { pageUrl: string } }, ApiResult2<any>>({
  Type: 'Post',
  Url: `${API_URL.COMMON}/anon/sem/op/save`,
})

export const DWSaveUrlHttp = DealWithHttp(SaveUrlHttp, HttpSuccessType2)

/*#region c5授权地址获取*/
const GetC5UrlHttp = BaseHttp<{ appId: string; state?: string; mobile?: string; cpsId?: number }, ApiResult3<C5Result>>(
  {
    Type: 'Get',
    Url: `${API_URL.BOX_WEB}/api/channel/authLogin`,
  },
)
export const DWGetC5UrlHttp = DealWithHttp(GetC5UrlHttp, HttpSuccessType2)

/*#region 用户数据*/
const UserCountHttp = BaseHttp<null, ApiResult<UserCount>>({ Type: 'Get', Url: `${API_URL.BOX}/api/getUserStat` })

const DWUserCountHttp = DealWithHttp<null, ApiResult<UserCount>, UserCount>(UserCountHttp, HttpSuccessType1)

export const UserCountHS = MobXHttp<null, UserCount, null>(DWUserCountHttp)
/*#endregion*/

/*#region 虚拟数据*/
export const VirtualPopularityHttp = BaseHttp<null, VirtualPopularity[]>({
  Type: 'Get',
  Url: `${API_URL.COMMON}/anon/virtual/popularity/info`,
})
/*#endregion*/

/*#region 渠道配置*/
const ChannelConfigHttp = BaseHttp<ChannelConfigQuery, ApiResult<ChannelConfig>>({
  Type: 'Get',
  Url: `${API_URL.BOX}/api/getChannelConfig`,
})

const DWChannelConfigHttp = DealWithHttp<ChannelConfigQuery, ApiResult<ChannelConfig>, ChannelConfig>(
  ChannelConfigHttp,
  HttpSuccessType1,
)

export const ChannelConfigHS = MobXHttp<ChannelConfigQuery, ChannelConfig, null>(DWChannelConfigHttp)
/*#endregion*/

/*#region 获取 CMS 配置*/
const GetModDataByModIdHttp = BaseHttp<
  { modId: string; version: string; mathRandom?: number },
  ApiResult2<ModData<any>>
>({
  Type: 'Get',
  Url: `${API_URL.ORIGIN}/fulu-page-cloud/anon/cms/getModDataByModId`,
})

export const DWGetModDataByModIdHttp = DealWithHttp(GetModDataByModIdHttp, HttpSuccessType2)
/*#endregion*/

/*#region 获取 CMS 配置*/
const GetVipLimitTimeHttp = BaseHttp<{ modId: string; version: string }, ApiResult2<ModData<any>>>({
  Type: 'Get',
  Url: `${API_URL.ORIGIN}/fulu-page-cloud/anon/cms/getModDataByModId`,
})

export const DWGetVipLimitTimeHttp = DealWithHttp(GetVipLimitTimeHttp, HttpSuccessType2)
/*#endregion*/

/*#region 获取 CMS 配置*/
const GetVipGameRecommendHttp = BaseHttp<{ modId: string; version: string }, ApiResult2<ModData<any>>>({
  Type: 'Get',
  Url: `${API_URL.ORIGIN}/fulu-page-cloud/anon/cms/getModDataByModId`,
})

export const DWGetVipGameRecommendHttp = DealWithHttp(GetVipGameRecommendHttp, HttpSuccessType2)
/*#endregion*/

/*#region 上报打开客户端*/
const javaReport = BaseHttp({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/common/anon/client/open`,
})

const DWjavaReportHttp = DealWithHttp(javaReport, HttpSuccessType2)

export const javaReportHS = MobXHttp(DWjavaReportHttp)
/*#endregion*/

/*#region 领取会员礼包*/
const ReceiveVipPackageHttp = BaseHttp<ReceiveVipPackageQuery, ApiResult<null>>({
  Type: 'Post',
  Url: `${API_URL.BOX}/api/receiveVipPackage`,
})

export const DWReceiveVipPackageHttp = DealWithHttp(ReceiveVipPackageHttp, HttpSuccessType1)

//const ReceiveVipPackageHS = MobXHttp(DWReceiveVipPackageHttp)

/*#endregion*/

/*#region 获取 CMS 配置 通过数据 ID*/
const GetModDataByDataIdHttp = BaseHttp<{ dataId: string; version?: string }, ApiResult2<ModDataItem<any>>>({
  Type: 'Get',
  Url: `${API_URL.ORIGIN}/fulu-page-cloud/anon/cms/getModDataByDataId`,
})

export const DWGetModDataByDataIdHttp = DealWithHttp(GetModDataByDataIdHttp, HttpSuccessType2)
/*#endregion*/

/*#region 获取游戏标签*/
const GameTagListHttp = BaseHttp<undefined, ApiResult<PageResult<GameTagInfo>>>({
  Type: 'Get',
  Url: `${API_URL.BOX}/api/gameTagList`,
})

const DWGameTagListHttp = DealWithHttp(GameTagListHttp, HttpSuccessType1)

export const GameTagListHS = MobXHttp(DWGameTagListHttp)
/*#endregion*/

/*#region 获取当前会话ID， 用于下载客户端时进行统计*/
const GetPreProcess = BaseHttp<
  { sem: string; searchKey: string; actLoadUrl: string; defalutLoadUrl: string },
  ApiResult2<{ id: string; loadFileName: string; loadUrl: string; location: string }>
>({
  Type: 'Get',
  Url: `${API_URL.COMMON}/anon/sem/pre/process`,
})

const DWGetPreProcess = DealWithHttp(GetPreProcess, HttpSuccessType2)

export const GetPreProcessHS = MobXHttp(DWGetPreProcess)
/*#endregion*/

/*#region 获取奖品列表*/
const unpackingPrizeList = BaseHttp<any, ApiResult2<TLuckyDrawGoods[]>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/anon/api/unpackingPrizeList`,
})

const DWunpackingPrizeList = DealWithHttp(unpackingPrizeList, HttpSuccessType2)

export const unpackingPrizeListHS = MobXHttp(DWunpackingPrizeList)
/*#endregion*/

/*#region 获取用户抽奖次数*/
const unpackingNum = BaseHttp<any, ApiResult2<number>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/unpackingNum`,
})

const DWunpackingNum = DealWithHttp(unpackingNum, HttpSuccessType2)

export const unpackingNumHS = MobXHttp(DWunpackingNum)
/*#endregion*/

/*#region 获取用户是否可以领取会员赠送的抽奖次数*/
const isReviceUnpackingNum = BaseHttp<any, ApiResult2<boolean>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/isReviceUnpackingNum`,
})

const DWisReviceUnpackingNum = DealWithHttp(isReviceUnpackingNum, HttpSuccessType2)

export const isReviceUnpackingNumHS = MobXHttp(DWisReviceUnpackingNum)
/*#endregion*/

/*#region 用户领取会员赠送的抽奖次数*/
const reviceUnpackingNum = BaseHttp<any, ApiResult2<boolean>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/reviceUnpackingNum`,
})

const DWreviceUnpackingNum = DealWithHttp(reviceUnpackingNum, HttpSuccessType2)

export const reviceUnpackingNumHS = MobXHttp(DWreviceUnpackingNum)
/*#endregion*/

/*#region 获取抽奖商品*/
const accounttype = BaseHttp<{ accounttype: 24 }, ApiResult2<any>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/anon/get/goods/list/by/accounttype`,
})

const DWaccounttype = DealWithHttp(accounttype, HttpSuccessType2)

export const accounttypeHS = MobXHttp(DWaccounttype)
/*#endregion*/

/*#region 用户抽奖*/
const unpackingLottery = BaseHttp<{ lotteryType: 1 | 2; channel?: string }, ApiResult2<any>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/unpackingLottery`,
})

const DWunpackingLottery = DealWithHttp(unpackingLottery, HttpSuccessType2)

export const unpackingLotteryHS = MobXHttp(DWunpackingLottery)
/*#endregion*/

/*#region 通过会话ID， 用于下载客户端时进行统计*/
const SemDownload = BaseHttp<{ id: string; refererGame?: string }, ApiResult2<string>>({
  Type: 'Get',
  Url: `${API_URL.ORIGIN}/fulu-common-cloud/anon/sem/download`,
})

const DWSemDownload = DealWithHttp(SemDownload, HttpSuccessType2)

export const SemDownloadHS = MobXHttp(DWSemDownload)
/*#endregion*/

/*#region 获取加速器价格*/
const SpeedPriceHttp = BaseHttp<undefined, ApiResult<SpeedPrice[]>>({
  Type: 'Get',
  Url: `${API_URL.BOX}/api/getJsqPrice`,
})

const DWSpeedPriceHttp = DealWithHttp(SpeedPriceHttp, HttpSuccessType1)

export const SpeedPriceHS = MobXHttp(DWSpeedPriceHttp)
/*#endregion*/

/*#region 下载壁纸*/
const DownWallpaperHttp = BaseHttp<DownWallpaperQuery, ApiResult<{}>>({
  Type: 'Get',
  Url: `${API_URL.BOX}/api/downWallpaper`,
})
export const DWDownWallpaperHttp = DealWithHttp(DownWallpaperHttp, HttpSuccessType1)
/*@endregion*/

/*#region 壁纸标签*/
const WallpaperTagHttp = BaseHttp<null, ApiResult<Array<WallpaperTag>>>({
  Type: 'Get',
  Url: `${API_URL.BOX}/api/wallpaperTag`,
})
const DWWallpaperTagHttp = DealWithHttp(WallpaperTagHttp, HttpSuccessType1)

export const WallpaperTagHS = MobXHttp(DWWallpaperTagHttp)
/*@endregion*/

/*#region 壁纸列表*/
const WallpaperListHttp = BaseHttp<WallpaperQuery, ApiResult<PageResult<WallpaperList>>>({
  Type: 'Get',
  Url: `${API_URL.BOX}/api/wallpaperList`,
})
const DWWallpaperListHttp = DealWithHttp(WallpaperListHttp, HttpSuccessType1)

export const WallpaperListHS = MobXHttp<WallpaperQuery, PageResult<WallpaperList>, null>(
  DWWallpaperListHttp,
  ResultPagination,
)
/*#endregion*/

/*#region 用户反馈*/
const UserFeedbackHttp = BaseHttp<FeedbackQuery, ApiResult<null>>({
  Type: 'Post',
  Url: `${API_URL.BOX_WEB}/api/feedback`,
})
export const DWUserFeedbackHttp = DealWithHttp(UserFeedbackHttp, HttpSuccessType1)
/*#endregion*/

/*#region 提交启动页诉求*/
const feedbackPetition = BaseHttp<{ content: string; channel: string; title: string }, ApiResult3<null>>({
  Type: 'Post',
  Url: `${API_URL.BOX_WEB}/feedback/petition`,
})
export const DWfeedbackPetition = DealWithHttp(feedbackPetition, HttpSuccessType2)
/*#endregion*/

/*#region 获取上传文件证书*/
const UploadPolicyHttp = BaseHttp<{ type: TUploadType }, ApiResult<UploadPolicy>>({
  Type: 'Get',
  Url: `${API_URL.BOX}/api/uploadPolicy`,
})
export const DWUploadPolicyHttp = DealWithHttp(UploadPolicyHttp, HttpSuccessType1)
/*#endregion*/

/*#region 常见问题-新闻列表*/
const HelpListHttp = BaseHttp<HelpListQuery, ApiResult<HelpListResult>>({
  Type: 'Get',
  Url: `${API_URL.BOX}/api/helpNewsList`,
})

const DWHelpListHttp = DealWithHttp(HelpListHttp, HttpSuccessType1)

export const HelpListHS = MobXHttp(DWHelpListHttp, ResultPagination)
/*#endregion*/

/*#region 新闻详情*/
const NewsDetailHttp = BaseHttp<NewsDetailQuery, ApiResult<NewsDetail>>({
  Type: 'Get',
  Url: `${API_URL.BOX}/api/newsDetail`,
})

const DWNewsDetailHttp = DealWithHttp(NewsDetailHttp, HttpSuccessType1)

export const NewsDetailHS = MobXHttp(DWNewsDetailHttp)
/*#endregion*/

/*#region 推荐新闻*/
const RecommendNewsHttp = BaseHttp<RecommendNewsQuery, ApiResult<RecommendNews>>({
  Type: 'Post',
  Url: `${API_URL.BOX}/api/recommendNews`,
})

export const DWRecommendNewsHttp = DealWithHttp(RecommendNewsHttp, HttpSuccessType1)
/*#endregion*/

/*#region 发送 CDK 短信*/
const SendCDKMessageHttp = BaseHttp<CDKMessageParams, ApiResult<null>>({
  Type: 'Post',
  Url: `${API_URL.BOX}/api/sendCdkMessage`,
})
export const DWSendCDKMessageHttp = DealWithHttp(SendCDKMessageHttp, HttpSuccessType1)

//export const SendCDKMessageHS = MobXHttp(DWSendCDKMessageHttp)
/*#endregion*/

/*#region 获取会员数量*/
const VipNumHttp = BaseHttp<null, ApiResult<{ num: number }>>({
  Type: 'Get',
  Url: `${API_URL.BOX}/api/getVipNum`,
})
export const DWVipNumHttp = DealWithHttp(VipNumHttp, HttpSuccessType1)
//export const DWVipNumHS = MobXHttp(DWVipNumHttp)
/*@endregion*/

/*#region 获取北京时间*/
const BeijingTime = BaseHttp<null, ApiResult<{ time: number }>>({
  Type: 'Get',
  Url: `${API_URL.BOX}/api/getCurrentTime`,
})
export const DWBeijingTime = DealWithHttp(BeijingTime, HttpSuccessType1)
/*#endregion*/

/*#region 获取 cms 版本*/
const CMSVersionHttp = BaseHttp<null, ApiResult2<string>>({
  Type: 'Get',
  Url: `${API_URL.ORIGIN}/fulu-page-cloud/anon/cms/getVersion`,
})

export const DWCMSVersionHttp = DealWithHttp(CMSVersionHttp, HttpSuccessType2)
/*#endregion*/

/*#region 获取多个 CMS 配置*/
const GetMultipleModDataByModIdHttp = BaseHttp<{ modIds: string; version: string }, ApiResult2<ModData<any>[]>>({
  Type: 'Get',
  Url: `${API_URL.ORIGIN}/fulu-page-cloud/anon/cms/getModDatasByModIds`,
})

export const DWGetMultipleModDataByModIdHttp = DealWithHttp(GetMultipleModDataByModIdHttp, HttpSuccessType2)
/*#endregion*/

/*#region 常见问题-新闻列表*/
const YqHelpListHttp = BaseHttp<{ groupIdSon?: string }, ApiResult<YqHelpListResult[]>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/getYqHelper`,
})

const DWYqHelpListHttp = DealWithHttp(YqHelpListHttp, HttpSuccessType1)

export const YqHelpListHS = MobXHttp(DWYqHelpListHttp)
/*#endregion*/

/*#region 获取客服url*/
const GetContactUrl = BaseHttp<
  { token: string; gameNo?: string; type: number; mtKey?: string },
  ApiResult2<ContactInfo>
>({
  Type: 'Get',
  Url: `${API_URL.COMMON}/cloud/customer/open/new`,
})

const DWGetContactUrl = DealWithHttp(GetContactUrl, HttpSuccessType2)

export const GetContactUrlHS = MobXHttp(DWGetContactUrl)
/*#endregion*/

/*#region 获取会员权限/价格(php)*/
const GetVipConfigHttp = BaseHttp<{ channel: string }, ApiResult<vipConfig>>({
  Type: 'Get',
  Url: `${API_URL.BOX}/api/getVipConfig`,
})

const DWGetVipConfigHttp = DealWithHttp(GetVipConfigHttp, HttpSuccessType1)

export const GetVipConfigHS = MobXHttp(DWGetVipConfigHttp)
/*#endregion*/

/*#region 获取会员权限/价格(java)*/
const GetVipConfigJavaHttp = BaseHttp<{ channel: string; activityNo?: string }, ApiResult3<VipConfigInstance[]>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/anon/get/box/vip/goods/list`,
})

const DWGetVipConfigJavaHttp = DealWithHttp(GetVipConfigJavaHttp, HttpSuccessType2)

export const GetVipConfigJavaHS = MobXHttp(DWGetVipConfigJavaHttp)
/*#endregion*/

/*#region 获取当前渠道配置信息 */
const getConfigByChannel = BaseHttp<{ channel: string }, ApiResult2<IChannelConfig>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/anon/api/getConfigByChannel`,
})

const DWGetConfigByChannel = DealWithHttp(getConfigByChannel, HttpSuccessType2)

export const GetConfigByChannelHS = MobXHttp(DWGetConfigByChannel)
/*#endregion*/

/*#region 检测当前用户是否参加9+1活动 */
const apckJoinActivity = BaseHttp<{ channel: string }, ApiResult2<{ payType: string }>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/apck/join/activity?activityType=nine_one`,
})

const DWapckJoinActivityHttp = DealWithHttp(apckJoinActivity, HttpSuccessType2)

export const apckJoinActivityHS = MobXHttp(DWapckJoinActivityHttp)
/*#endregion*/

/*#region 统计接口 */
const statisticsApi = BaseHttp<null, ApiResult<vipConfig>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/anon/goods/detail/first/open/up`,
})

const DWstatisticsApiHttp = DealWithHttp(statisticsApi, HttpSuccessType1)

export const statisticsApiHS = MobXHttp(DWstatisticsApiHttp)
/*#endregion*/

/*#region 是否满足极速退款 */
const isFastRefund = BaseHttp<
  { userGameId?: number; orderNo?: string },
  ApiResult2<{ speedRefund: boolean; status: 2 | 6 | 10 }>
>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/anon/is/suffice/speed/refund`,
})

export const DWisFastRefundHttp = DealWithHttp(isFastRefund, HttpSuccessType2)

export const isFastRefundHS = MobXHttp(DWisFastRefundHttp)
/*#endregion*/

/*#region 获取论坛帖子 */
const getAllByGameId = BaseHttp<PostsParams, ApiResult2<PageBBSResult<TBBSListItem>>>({
  Type: 'Get',
  Url: `${API_URL.BBS_WEB}/api/box/anon/topic/getAllByGameId`,
})

export const DWgetAllByGameIdHttp = DealWithHttp(getAllByGameId, HttpSuccessType2)

export const getAllByGameIdHS = MobXHttp(DWgetAllByGameIdHttp)
/*#endregion*/

/** 获取我参与过的帖子列表 */
const getJoinTopicsList = BaseHttp<GetMyPostsParams, ApiResult2<PageBBSResult<TBBSListItem>>>({
  Type: 'Get',
  Url: `${API_URL.BBS_WEB}/api/box/inner/comment/getAllTopicByComment`,
})

const DWGetJoinTopicsList = DealWithHttp(getJoinTopicsList, HttpSuccessType2)
export const getJoinTopicsListHS = MobXHttp(DWGetJoinTopicsList)

/*#region 获取自己发布的帖子 */
const getMyTopicsHttp = BaseHttp<GetMyPostsParams, ApiResult2<TGetMyTopicsHttp>>({
  Type: 'Get',
  Url: `${API_URL.BBS_WEB}/api/box/inner/topic/getUser/topics`,
})

const DWgetMyTopicsHttpHttp = DealWithHttp(getMyTopicsHttp, HttpSuccessType2)

export const getMyTopicsHS = MobXHttp(DWgetMyTopicsHttpHttp)
/*#endregion*/

/*#region 获取帖子详情 */
const getTopicDetailByIdHttp = BaseHttp<
  { id: number; pageSize: number; pageNo: number; isDel?: number },
  ApiResult2<TGetTopicDetailByIdResult>
>({
  Type: 'Get',
  Url: `${API_URL.BBS_WEB}/api/box/topic/detailById`,
})

export const DWgetTopicDetailByIdHttpHttp = DealWithHttp(getTopicDetailByIdHttp, HttpSuccessType2)

export const getTopicDetailByIdHS = MobXHttp(DWgetTopicDetailByIdHttpHttp)
/*#endregion*/

/*#region 根据id删除帖子 */
const topicDelByIdHttp = BaseHttp<{ id: number }, ApiResult2<TGetTopicDetailByIdResult>>({
  Type: 'Get',
  Url: `${API_URL.BBS_WEB}/api/box/inner/topic/deleteById`,
})

const DWtopicDelByIdHttp = DealWithHttp(topicDelByIdHttp, HttpSuccessType2)

export const topicDelByIdHS = MobXHttp(DWtopicDelByIdHttp)
/*#endregion*/

/*#region 发布评论  */
const commentCreateHttp = BaseHttp<
  { topicId?: number; commentId?: number; content: string; fistCommentId?: number; imgs?: string },
  ApiResult2<TGetTopicDetailByIdResult>
>({
  Type: 'Post',
  Url: `${API_URL.BBS_WEB}/api/box/inner/comment/create`,
})

const DWcommentCreateHttpHttp = DealWithHttp(commentCreateHttp, HttpSuccessType2)

export const commentCreateHS = MobXHttp(DWcommentCreateHttpHttp)
/*#endregion*/

/* 编辑 论坛帖子*/
const editorTopic = BaseHttp<CreatePostsParams, ApiResult2<any>>({
  Type: 'Post',
  Url: `${API_URL.BBS_WEB}/api/box/inner/topic/editById`,
})

const DWeditorTopicHttp = DealWithHttp(editorTopic, HttpSuccessType2)

export const editorTopicHS = MobXHttp(DWeditorTopicHttp)

/*#region 发布论坛帖子 */
const createTopic = BaseHttp<CreatePostsParams, ApiResult2<any>>({
  Type: 'Post',
  Url: `${API_URL.BBS_WEB}/api/box/inner/topic/create`,
})

const DWcreateTopicHttp = DealWithHttp(createTopic, HttpSuccessType2)

export const createTopicHS = MobXHttp(DWcreateTopicHttp)
/*#endregion*/

/*#region 提取第三方商品 */
const extractGoods = BaseHttp<{ orderNo: string }, ApiResult2<{ speedRefund: boolean; status: 2 | 6 | 10 }>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/manual/allocation`,
})

const DWextractGoodsHttp = DealWithHttp(extractGoods, HttpSuccessType2)

export const extractGoodsHS = MobXHttp(DWextractGoodsHttp)

type TCardGoods = {
  containNum: number
  discoutStr: string
  id: number
  price: number
  productName: string
  sort: number
}
/*#region 获取换购卡商品列表 */
const cardGoodsList = BaseHttp<any, ApiResult2<TCardGoods[]>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/anon/get/share/change/card/goods/list`,
})

const DWcardGoodsListHttp = DealWithHttp(cardGoodsList, HttpSuccessType2)

export const cardGoodsListHS = MobXHttp(DWcardGoodsListHttp)
/*#endregion*/

/*#region 获取更新日志 */
const autoBuild = BaseHttp<
  { product?: string; ver?: string; type?: string; channel?: string },
  ApiResult4<{ description: any }>
>({
  Type: 'Get',
  Url: `https://api.zuhaohao.com/fulu-common-cloud/anon/autoBuild/get`,
})

const DWautoBuildHttp = DealWithHttp(autoBuild, HttpSuccessType4)

export const autoBuildHS = MobXHttp(DWautoBuildHttp)
/*#endregion*/

/*#region 获取用户是否拥有该商品 */
const getGamePlayList = BaseHttp<
  { gameId: string | number },
  ApiResult2<{ id: number; type: 1 | 7; ctime: string; gameLibraryId: number }[]>
>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/play/game/list/get`,
})

const DWgetGamePlayListHttp = DealWithHttp(getGamePlayList, HttpSuccessType2)

export const getGamePlayListHS = MobXHttp(DWgetGamePlayListHttp)
/*#endregion*/

/*#region 删除用户评论 */
const deleteCommentById = BaseHttp<{ id: number }, ApiResult2<{ id: number; type: 1 | 7; ctime: string }[]>>({
  Type: 'Get',
  Url: `${API_URL.BBS_WEB}/api/box/inner/comment/deleteCommentById`,
})

const DWdeleteCommentByIdHttp = DealWithHttp(deleteCommentById, HttpSuccessType2)

export const deleteCommentByIdHS = MobXHttp(DWdeleteCommentByIdHttp)
/*#endregion*/

/*#region 获取回复我的列表 */
const getAllCommentOrReplyMeHttp = BaseHttp<GetMyPostsParams, ApiResult2<PageBBSResult<TGetAllCommentOrReplyMeResult>>>(
  {
    Type: 'Get',
    Url: `${API_URL.BBS_WEB}/api/box/inner/comment/getAllCommentOrReplyMe`,
  },
)

const DWgetAllCommentOrReplyMeHttp = DealWithHttp(getAllCommentOrReplyMeHttp, HttpSuccessType2)

export const getAllCommentOrReplyMeHS = MobXHttp(DWgetAllCommentOrReplyMeHttp)
/*#endregion*/

/*#region 获取未读列表 */
const getNotReadByGameHttp = BaseHttp<GameLibraryId, ApiResult2<number>>({
  Type: 'Get',
  Url: `${API_URL.BBS_WEB}/api/box/inner/message/notReadByGame`,
})

const DWgetNotReadByGameHttp = DealWithHttp(getNotReadByGameHttp, HttpSuccessType2)

export const getNotReadByGameHttpHS = MobXHttp(DWgetNotReadByGameHttp)
/*#endregion*/

/*#region 未读标记已读 */
const markReadByGameHttp = BaseHttp<GameLibraryId, ApiResult2<number>>({
  Type: 'Get',
  Url: `${API_URL.BBS_WEB}/api/box/inner/message/markReadByGame`,
})

const DWmarkReadByGameHttp = DealWithHttp(markReadByGameHttp, HttpSuccessType2)

export const markReadByGameHS = MobXHttp(DWmarkReadByGameHttp)
/*#endregion*/

/*#region 未读标记已读 */
const autoUserHasReadHttp = BaseHttp<GameLibraryId, ApiResult2<number>>({
  Type: 'Get',
  Url: `${API_URL.BBS_WEB}/api/box/inner/user/autoUserHasRead`,
})

const DWautoUserHasReadHttp = DealWithHttp(autoUserHasReadHttp, HttpSuccessType2)

export const autoUserHasReadHS = MobXHttp(DWautoUserHasReadHttp)
/*#endregion*/

/*#region 上报云存档下载次数 */
const reportCloudArchivesDownloadNum = BaseHttp<
  { orderNo: string },
  ApiResult2<{ id: number; type: 1 | 7; ctime: string }[]>
>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/api/addArchiveDownloadNum`,
})

const DWreportCloudArchivesDownloadNumHttp = DealWithHttp(reportCloudArchivesDownloadNum, HttpSuccessType2)

export const reportCloudArchivesDownloadNumHS = MobXHttp(DWreportCloudArchivesDownloadNumHttp)
/*#endregion*/

/*#region 上报打开客户端 */
const reportClientOpen = BaseHttp({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/common/anon/client/open`,
})

const DWreportClientOpenHttp = DealWithHttp(reportClientOpen, HttpSuccessType2)

export const reportClientOpenHS = MobXHttp(DWreportClientOpenHttp)
/*#endregion*/

/** 获取微信授权地址*/
const getAuthCodeHttp = BaseHttp<{ channel?: string }, ApiResult2<{ url: string; sceneId: string }>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/anon/wechat/gzh/getLoginQrcode`,
})

const DWgetAuthCodeHttp = DealWithHttp(getAuthCodeHttp, HttpSuccessType2)

export const getAuthCodeHttpHS = MobXHttp(DWgetAuthCodeHttp)

/** 获取微信授权状态*/
const checkOfficeLoginHttp = BaseHttp<{ sceneId: string; channel?: string }, ApiResult3<CheckOfficeLoginHttpResult>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/anon/wechat/gzh/checkLogin`,
})

const DWcheckOfficeLoginHttp = DealWithHttp(checkOfficeLoginHttp, HttpSuccessType2)

export const checkOfficeLoginHttpHS = MobXHttp(DWcheckOfficeLoginHttp)

/** 手机登录绑定微信, 或者微信登录绑定手机 */
const phoneLoginBindWX = BaseHttp<
  { mobile: string; mobileCode: string; sceneId: string; channel?: string },
  ApiResult3<string>
>({
  Type: 'Post',
  Url: `${API_URL.BOX_WEB}/anon/wechat/gzh/bindMobile`,
})

const DWphoneLoginBindWX = DealWithHttp(phoneLoginBindWX, HttpSuccessType2)

export const phoneLoginBindWXHS = MobXHttp(DWphoneLoginBindWX)

/*#region 获取活动玩游戏时长排行榜 */
const getGameTimeRank = BaseHttp<{ activityNo: string; lastWeek?: 1 | 0 }, ApiResult2<TgameTimeRank>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/activity/play/game/time/rank`,
})

const DWgetGameTimeRank = DealWithHttp(getGameTimeRank, HttpSuccessType2)

export const getGameTimeRankHS = MobXHttp(DWgetGameTimeRank)
/*#endregion*/
/**手机号绑定微信， 获取微信二维码， 检测微信二维码是否扫描成功 */
const checkBindWechatSuccess = BaseHttp<{ sceneId: string; channel?: string }, ApiResult3<CheckOfficeLoginHttpResult>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/anon/wechat/gzh/checkBind`,
})

const DWCheckBindWechatSuccess = DealWithHttp(checkBindWechatSuccess, HttpSuccessType2)

export const checkBindWechatSuccessHS = MobXHttp(DWCheckBindWechatSuccess)

/** 手机号绑定微信，获取微信二维码 */
const bindWechatByPhone = BaseHttp<{ channel?: string }, ApiResult3<{ url: string; sceneId: string }>>({
  Type: 'Get',
  Url: `${API_URL.BOX_WEB}/anon/wechat/gzh/getBindQrcode`,
})

const DWBindWechatByPhone = DealWithHttp(bindWechatByPhone, HttpSuccessType2)

export const bindWechatByPhoneHS = MobXHttp(DWBindWechatByPhone)

/** 上报 */
const eventCollet = BaseHttp<TeventColletQuery, ApiResult3<null>>({
  Type: 'Post',
  Url: `${API_URL.COMMON}/anon/event/collet`,
})

export const DWeventCollet = DealWithHttp(eventCollet, HttpSuccessType2)

/** 上报 */
const JAVALogHttp = BaseHttp<any, ApiResult3<null>>({
  Type: 'Post',
  Url: `${API_URL.COMMON}/anon/event/collet`,
})

export const DWJAVALogHttp = DealWithHttp(JAVALogHttp, HttpSuccessType2)

/** 获取渠道配置  */
const getChannelConfigByName = BaseHttp<{ channel: string; fieldName: string }, ApiResult3<string>>({
  Type: 'Get',
  Url: `${API_URL.BOX}/anon/channel/dynamic/extend`,
})

export const DWGetChannelConfigByName = DealWithHttp(getChannelConfigByName, HttpSuccessType2)

/** 获取订单信息  */
const getOrderInfo = BaseHttp<{ orderNo?: string; userGameId?: number }, ApiResult3<OrderInfo>>({
  Type: 'Get',
  Url: `${API_URL.BOX}/order/info`,
})

export const DWGetOrderInfo = DealWithHttp(getOrderInfo, HttpSuccessType2)

// 已废弃
/*#region 上报用户引导打开了*/
// const sendOpenGuide = BaseHttp<{ plate: string }, ApiResult3<null>>({
//   Type: 'Post',
//   Url: `${API_URL.BOX_WEB}/api/user/guide/report`,
// })

// export const DWSendOpenGuide = DealWithHttp(sendOpenGuide, HttpSuccessType2)
